import CategoryQuestionDesigner from './CategoryQuestionDesigner';
import { CATEGORY_QUESTION_TYPE } from './constants';

/**
 * Registration for the shared Questionnaire Designer:
 *
 * customQuestionTypes={{
 *   category: categoryCustomQuestionType
 * }}
 *
 * Wired from the GDPR questionnaire edit page (Task 6).
 */
export const categoryCustomQuestionType = {
    meta: {
        title: 'Category',
        value: CATEGORY_QUESTION_TYPE,
        icon: 'ri-folder-line',
        placeholder: 'Category',
        isDefault: false
    },
    Designer: CategoryQuestionDesigner
};

export { CategoryQuestionDesigner, CATEGORY_QUESTION_TYPE };
export default categoryCustomQuestionType;
